import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Accordion, AccordionActions, AccordionDetails, Button, Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import './styles.scss';
import { MdCached, MdAddCircleOutline, MdClose } from 'react-icons/md';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Refresh } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import MaterialTable from '@material-table/core';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { NotificationManager } from 'react-notifications';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import { createMuiTheme } from '@mui/styles';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


function MenuRoleComponent(props) {
    useEffect(() => {
        props.GetDataMenuAll();
        props.GetDataRolesAll();
        props.GetDataMenuRoles()
        // eslint-disable-next-line
    }, []
    );
    useEffect(() => {
        if (props.isResult) {
            props.GetDataMenuAll();
            props.GetDataRolesAll();
            props.GetDataMenuRoles()
        }
        // eslint-disable-next-line
    }, [props.isResult]);
    const [menuItem, setMenuItem] = useState();
    const [roleItem, setRoleItem] = useState([]);
    // eslint-disable-next-line
    const [expanded, setExpanded] = React.useState('panel1');
    const [valueKey, setKey] = useState();
    const [valueDescription, setDescription] = useState('');
    // eslint-disable-next-line
    const [readOnly, setReadOnly] = React.useState(false);
    // eslint-disable-next-line
    const [menuNew, setMenuNew] = useState();
    const [idModal, setIDModal] = useState();
    // eslint-disable-next-line
    const [keys, setKeys] = useState([
        { title: "Select", value: 1 },
        { title: "Insert", value: 2 },
        { title: "Update", value: 3 },
        { title: "Delete", value: 4 },
        { title: "Khác...", value: -1 }
    ]);
    const [keyText, setKeyText] = useState('');
    const [isShow, setShow] = useState(false);
    const [openM, setOpenM] = React.useState(false);

    const handleClickOpen = (id) => {
        //console.log(id);
        setIDModal(id);
        setOpenM(true);
    };

    const handleClose = () => {
        setOpenM(false);
    };

    const DeleteButton = (id) => {
        //console.log(id);
        const Datadelete = {
            "ID": id
        };
        props.DeleteDataMenuRoles(Datadelete);
        setOpenM(false);
    };
    // const EditButton = (DataMenuRoles) => {
    //     setReadOnly(true);
    //     setKey(DataMenuRoles.key);
    //     setDescription(DataMenuRoles.description);
    //     const menuItem = props.DataMenu.find(item => item.id == DataMenuRoles.menuID);
    //     if (menuItem) {
    //         setMenuItem(menuItem);
    //     }
    //     const roleItem = props.DataRoles.find(item => item.id == DataMenuRoles.roleID);
    //     if (roleItem) {
    //         setRoleItem([]);
    //         setRoleItem(prev => [...prev, roleItem]);
    //     }
    // };
    //<IconButton className="editicon" onClick={() => EditButton(rowData)} ><EditIcon /></IconButton>

    const state = {
        columns: [
            { title: 'Menu', width: 300, field: 'nameMenu', filtering: false, editable: 'never' },
            { title: 'Role', width: 300, field: 'nameRole', filtering: false, editable: 'never' },
            { title: 'Quyền', width: 300, field: 'key', filtering: false, editable: 'never' },
            { title: 'Mô tả', width: 300, field: 'description', filtering: false, editable: 'never' },
            {
                title: 'Thao tác', width: 300, field: 'id', render: rowData => <div><IconButton className="deleteicon" onClick={() => handleClickOpen(rowData.id)} ><DeleteOutlineIcon /></IconButton>
                    <Dialog
                        open={openM}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{boxShadow: 'none'}}
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Xác nhận!"}
                            <IconButton style={{ marginLeft: 250 }} onClick={handleClose}><MdClose /></IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Bạn có thực sự chắc chắn muốn xóa menu role này?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="PlanTemplate_0021 text-light" style={{ backgroundColor: '#DA9630' }} onClick={handleClose}  >
                                Hủy
                            </Button>
                            <Button className="PlanTemplate_0021 text-light" size='small' onClick={() => DeleteButton(idModal)} variant="contained" style={{ backgroundColor: 'var(--itsm-bg-btn)' }} autoFocus>
                                Xác nhận
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>, filtering: false, editable: 'never'
            },

            //{ title: 'Thao tác', width: 300, field: 'id', render: rowData => <div><IconButton className="deleteicon" onClick={() => DeleteButton(rowData.id)} ><DeleteOutlineIcon /></IconButton> </div>, filtering: false, editable: 'never' },
        ]
    };
    const fn_SetMenuItem = (newValue) => {
        setMenuItem(newValue);
    }
    const resetMenuRole = () => {
        setShow(false)
        // setReadOnly(!readOnly);
        setKey("");
        setDescription("");
        setMenuItem("");
        setRoleItem([]);
    }
    const handleKey = (newValue, reason) => {
        if(reason === 'clear')
        {
            setKey(null);
            return false;
        }
        if (newValue.value === -1) {
            setKey({ title: "", id: -1 });
            setShow(true);
        }
        else {
            setKey(newValue);
        }
    };
    const handleKeyText = (event) => {
        setKeyText(event.target.value);
    };
    const handleDescription = (event) => {
        setDescription(event.target.value);
    };
    

    const saveMenuRole = () => {
        if (!menuItem) {
            NotificationManager.error("Vui lòng chọn menu !");
            return false;
        }
        if (roleItem.length === 0 ) {
            NotificationManager.error("Vui lòng chọn role !");
            return false;
        }
        if (!valueKey) {
            NotificationManager.error("Vui lòng nhập quyền");
            return false;
        }
        if (valueKey.id === -1 && !keyText ) {
            NotificationManager.error("Vui lòng nhập quyền");
            return false;
        }
        //console.log(valueKey);
        let ListRole = "";
        if (roleItem) {
            roleItem.forEach((item, i) => {
                if (item.id === -1) {
                    ListRole = "";
                }
                else {
                    ListRole = ListRole + "," + item.id;
                }
            });
        }
        let Key = "";
        if (valueKey.id === -1) {
            Key = keyText;
        }
        else {
            Key = valueKey.title;
        }
        const DataMenuRoles = {
            "MenuID": menuItem.id,
            "Key": Key,
            "Description": valueDescription,
            "ListRole": ListRole.substring(1)
        };
        if (isDuplicate(menuItem, ListRole.substring(1)) === 0) {
            props.SetDataMenuRoles(DataMenuRoles);
            //window.location.reload();
        }
        else {
            console.log("Trùng");
        }

    }
    const isDuplicate = (menu, arr) => {
        let arrRoles = arr.split(',');
        let flag = 0;
        props.DataMenuRoles.forEach((item, i) => {
            arrRoles.forEach((itemr, j) => {
                if (item.menuID === menu.id && parseInt(itemr) === item.roleID) {
                    NotificationManager.error("Đã tồn tại menu " + item.nameMenu + " của role " + item.nameRole);
                    flag = 1;
                }
            })
        });
        return flag;
    }

    const [Roles, SetRoles] = useState();
    useEffect(() => {
        if (props.DataRoles !== undefined && props.DataRoles) {
            SetRoles([{ id: -1, name: "Tất cả" }, ...props.DataRoles])
        };
    }, [props.DataRoles])

    const fn_SetRoleItem = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.id === -1) || (!newValue.some(x => x.id === -1) && newValue.length === Roles.length - 1)) {
                setRoleItem(Roles);
            }
            else {
                setRoleItem(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.id === -1)) {
                var index = newValue.findIndex(x => x.id === -1);
                setRoleItem([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.id === -1) && newValue.length === Roles.length - 1) {
                setRoleItem([]);
            }
            else {
                setRoleItem(newValue);
            }
        }
        else if (reason === "clear") {
            setRoleItem([]);
        }
    }
    const handleRefresh = () => {
        setShow(!isShow);
        setKey(null);
        setKeyText('');
    }

    return (
        <div className='Bodyui'>
            <div className='PlanTemplate_body'>
                <Accordion className='PlanTemplate_002' expanded={expanded === 'panel1'}>
                    <AccordionDetails >
                        <div className="col-md-6 PlanTemplate_0014">
                            <Autocomplete
                                disablePortal
                                id="combo-box"
                                size='small'
                                disableClearable={readOnly}
                                options={props.DataMenu ? props.DataMenu : []}
                                getOptionLabel={(option) => option.name}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Menu" variant="outlined" />}
                                renderOption={(option) =>
                                    <Typography noWrap style={{ fontSize: "13px" }}>{option.name}</Typography>}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue) => fn_SetMenuItem(newValue)}
                                value={menuItem ? menuItem : null}
                            />
                        </div>
                        <div className="col-md-6 PlanTemplate_0014">
                            <Autocomplete
                                multiple
                                id="combo-box"
                                limitTags={5}
                                options={Roles ? Roles : []}
                                disableCloseOnSelect
                                disableClearable={readOnly}
                                renderOption={(option, { selected }) => {
                                    return (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            <Typography noWrap style={{ fontSize: "13px" }}>{option.name}</Typography>
                                        </React.Fragment>
                                    )
                                }}
                                // filterOptions={(options, params) => {
                                //     console.log("options", options)
                                //     console.log("params", params)
                                //     // const filtered = filter(options, params);
                                //     return [{ name: "Tất cả", id: -1 }, ...options];
                                // }}
                                getOptionLabel={(option) => option.name}
                                style={{ width: "100%" }}
                                size='small'
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true,
                                }} margin="dense" label="Role" variant="outlined" />}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue, reason) => fn_SetRoleItem(newValue, reason)}
                                value={roleItem}
                            />
                        </div>
                        <div className="col-md-6 PlanTemplate_0014">
                            <Autocomplete
                                disablePortal
                                id="combo-box"
                                size='small'
                                disableClearable={readOnly}
                                options={keys ? keys : []}
                                getOptionLabel={(option) => option.title}
                                style={{ width: "100%" }}
                                renderInput={(params) => <TextField {...params} InputLabelProps={{
                                    shrink: true
                                }} margin="dense" label="Quyền" variant="outlined" />}
                                renderOption={(option) =>
                                    <Typography noWrap style={{ fontSize: "13px" }}>{option.title}</Typography>}
                                className="PlanTemplate_0013"
                                onChange={(e, newValue,reason) => handleKey(newValue, reason)}
                                value={valueKey ? valueKey : null}
                                hidden={isShow}
                            />
                            <div className='mt-2' hidden={!isShow}>
                                <TextField
                                    //required
                                    id="outlined-required"
                                    variant="outlined"
                                    label="Quyền"
                                    placeholder="Vui lòng nhập quyền "
                                    onChange={(event) => handleKeyText(event)}
                                    value={keyText}
                                    size="small"
                                    style={{ width: "100%" ,fontSize: "10px" }}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton size='small' className="editicon" onClick={handleRefresh} ><Refresh /></IconButton>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2 PlanTemplate_0014">
                            <TextField
                                id="outlined-required"
                                variant="outlined"
                                label="Mô tả"
                                placeholder="Mô tả"
                                onChange={(event) => handleDescription(event)}
                                value={valueDescription ? valueDescription : ""}
                                size="small"
                                style={{ width: "100%", fontSize: "10px" }}
                            />
                        </div>
                    </AccordionDetails>
                    <AccordionActions className="PlanTemplate_btnAction">
                        <Button className="PlanTemplate_0021" onClick={saveMenuRole} size="small" startIcon={<MdAddCircleOutline />} variant="contained" color="primary">Thêm</Button>
                        <Button className="PlanTemplate_0021" size="small" onClick={resetMenuRole} startIcon={<MdCached />} variant="contained" color="primary">Reset</Button>
                    </AccordionActions>
                </Accordion>
            </div>
            <div className='tablelistsms'>
                <MaterialTable
                    columns={state.columns}
                    data={props.DataMenuRoles}
                    style={{
                        borderRadius: '20px',
                        boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px'
                    }}
                    options={{
                        toolbar: true,
                        paging: true,
                        exportButton: {
                            csv: true,
                            pdf: false
                        },
                        exportAllData: true,
                        filtering: true,
                        //selection: true,
                        headerStyle: {
                            backgroundColor: 'var(--itsm-bg-btn)',
                            color: '#FFF',
                            marginTop: '1%',
                            textAlign: 'center'
                        },
                        actionsColumnIndex: -1
                    }}
                    localization={{
                        pagination: {
                            labelDisplayedRows: 'Từ {from} - đến {to} of {count}'
                        },
                        toolbar: {
                            exportCSVName: "Export danh sách chi tiết",
                            nRowsSelected: 'Đã chọn {0} dòng',
                        },
                        header: {
                            actions: ''
                        },
                        body: {
                            emptyDataSourceMessage: 'Không có dữ liệu',
                            deleteTooltip: "Xóa",
                            filterRow: {
                                filterTooltip: 'Filter'
                            },
                            editRow: {
                                deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                cancelTooltip: "Hủy bỏ",
                                saveTooltip: "Đồng ý",
                            },
                        },
                    }}
                    title=""
                />
            </div>
        </div>
    );
}
export default MenuRoleComponent;